import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { EducationModal } from "./EducationModal";
import { useDeleteUserProfileSectionItem } from "Constant/apiHooks";
import { VIEW_PROFILE_SECTIONS } from "Constant/constants";
import { formatMonthYear } from "Utils";

export const Education = ({
  educationList,
  fetchData,
  isCurrentUserProfile,
}) => {
  const { t } = useTranslation();

  const { deleteUserProfileSectionItem } = useDeleteUserProfileSectionItem();

  const [educationModal, setShowEducationModal] = useState(false);
  const [selectedEducation, setSelectedEducation] = useState(null);

  const toggleEducationModal = (edu) => {
    setShowEducationModal((prev) => !prev);
    if (edu) {
      setSelectedEducation(edu);
    } else {
      setSelectedEducation(null);
    }
  };

  const handleDeleteEducation = async (gid) => {
    try {
      const payload = {
        key: VIEW_PROFILE_SECTIONS.education,
        [VIEW_PROFILE_SECTIONS.education]: {
          gid,
        },
      };
      await deleteUserProfileSectionItem(payload);
      fetchData();
    } catch {
      toast.error(t("common.messages.notification.failed.somethingWentWrong"));
    }
  };

  return (
    <>
      <div className="p-4 rounded-lg border border-grey-200 bg-white d-flex flex-column gap-0">
        <div className="d-flex flex-wrap justify-content-between align-items-center column-gap-3 row-gap-2 mb-3">
          <div>
            <h4 className="mb-0 text-md font-semibold text-grey-800">
              {t("auth.viewProfile.education")}
            </h4>
            {educationList.length === 0 && (
              <span className="text-grey-400">
                {t("auth.viewProfile.noEducation.info")}
              </span>
            )}
          </div>
          {isCurrentUserProfile && (
            <div className="d-flex align-items-center gap-1">
              <Button
                className="btn btn-gray-light font-medium rounded-lg d-inline-flex align-items-center gap-1"
                onClick={() => toggleEducationModal()}
              >
                <i className="bx bx-plus"></i>{" "}
                {t("auth.viewProfile.addEducation")}
              </Button>
            </div>
          )}
        </div>

        <ul className="exp-highlight-list list-unstyled mb-0 d-flex flex-column justify-content-center row-gap-1">
          {educationList && educationList.length > 0 ? (
            educationList.map((edu, idx) => (
              <li key={idx.toString()}>
                <div className="d-flex gap-3 py-4">
                  <div className="w-16 h-16 flex-auto rounded-circle overflow-hidden d-flex justify-content-center align-items-center bg-grey-100">
                    <img
                      src="/assets/images/placeholder.jpg"
                      alt=""
                      className="w-100 h-100 object-fit-cover"
                    />
                  </div>
                  <div className="d-flex flex-column gap-1 w-100">
                    <div className="d-flex gap-3">
                      <h5 className="mb-0 text-base font-semibold text-grey-800">
                        {t("common.label.degree")} | {edu.degree}
                      </h5>
                      {isCurrentUserProfile && (
                        <div className="ms-auto d-flex align-items-center gap-3">
                          <Button
                            variant="link"
                            className="p-0 text-base font-semibold text-grey-800 text-decoration-none"
                            onClick={() => toggleEducationModal(edu)}
                          >
                            <i className="bx bx-pencil"></i>
                          </Button>
                          <Button
                            variant="link"
                            className="p-0 text-base text-grey-800 text-decoration-none"
                            onClick={() => handleDeleteEducation(edu.gid)}
                          >
                            <i className="bx bx-trash"></i>
                          </Button>
                        </div>
                      )}
                    </div>
                    <span>{edu.major}</span>
                    <span>
                      {edu.institution}, {edu.location}
                    </span>
                    <span>
                      {edu.startDate && formatMonthYear(edu.startDate)}
                      {" - "} {edu.endDate && formatMonthYear(edu.endDate)}
                    </span>
                    <span>
                      {t("common.label.gpa")}
                      {": "}
                      {edu.gpa}
                    </span>
                  </div>
                </div>
              </li>
            ))
          ) : (
            <li>
              <div className="d-flex gap-3 py-4">
                <div className="w-16 h-16 flex-auto rounded-circle overflow-hidden d-flex justify-content-center align-items-center bg-grey-100">
                  <img
                    src="/assets/images/placeholder.jpg"
                    alt=""
                    className="w-100 h-100 object-fit-cover"
                  />
                </div>
                <div className="d-flex flex-column gap-1 w-100">
                  <h5 className="mb-1 text-base font-semibold text-grey-400">
                    {" "}
                    {t("auth.viewProfile.noEducation.degree")}
                  </h5>
                  <span className="text-grey-400">
                    {t("auth.viewProfile.noEducation.major")}
                  </span>
                  <span className="text-grey-400">
                    {t("auth.viewProfile.noEducation.institution")}
                    {", "}
                    {t("auth.viewProfile.noEducation.location")}
                  </span>
                  <span className="text-grey-400">
                    {t("auth.viewProfile.noEducation.startAndEndDate")}
                  </span>
                </div>
              </div>
            </li>
          )}
        </ul>
      </div>

      {educationModal && (
        <EducationModal
          show={educationModal}
          educationData={selectedEducation}
          toggle={toggleEducationModal}
          fetchData={fetchData}
        />
      )}
    </>
  );
};
